// 1главное хранилище - сюда приходят все узлы запросов
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authApi } from "./entities/auth.entity/redux/api";
import { authReducer, authSlice } from "./entities/auth.entity/redux/slice";
import { registrationReducer } from "./entities/auth.entity/redux/slice/registrationSlice";
import { userApi } from "./entities/user.entity/redux/api";
import {
	usersFilterReducer,
	usersFilterSlice,
	usersRequestPasswordFilterReducer,
	usersRequestPasswordFilterSlices,
} from "./entities/user.entity/redux/slice";
import { pingApi } from "./entities/ping.entity/redux/api";
import { regionApi } from "./entities/region.entity/redux/api";
import { themeReducer, themeSlice } from "./entities/theme.entity/redux/slice";
import { loyaltyProgramApi } from "./entities/loyaltyProgram.entity/redux/api";

import { profileUserApi } from "./entities/profileEdit.entity/ProfileUserApi";
import { profileEducationApi } from "./entities/profileEdit.entity/ProfileEducationApi";
import { profilePassportApi } from "./entities/profileEdit.entity/ProfilePassportApi";
import { profileLivingApi } from "./entities/profileEdit.entity/ProfileLivingApi";
import { profileWorkApi } from "./entities/profileEdit.entity/ProfileWorkApi";
import { profileSearchDoctorApi } from "./entities/profileEdit.entity/ProfileSeachDoctorApi";
import { profileInterestApi } from "./entities/profileEdit.entity/ProfileInterestApi";

import { materialEventsApi } from "./entities/materialEvents.entity/materialEventsAPI";
//GENERALPAGE - страницы не в /lk
import { OrganizationInfoAPI } from "./entities/GeneralPage.entity/OrganizationInfoAPI";

const allSliceReducersReducer = combineReducers({
	[authApi.reducerPath]: authApi.reducer,
	registration: registrationReducer,
	[authSlice.name]: authReducer,
	[usersFilterSlice.name]: usersFilterReducer,
	[userApi.reducerPath]: userApi.reducer,
	[pingApi.reducerPath]: pingApi.reducer,
	[usersRequestPasswordFilterSlices.name]: usersRequestPasswordFilterReducer,
	[regionApi.reducerPath]: regionApi.reducer,
	[themeSlice.name]: themeReducer,
	[loyaltyProgramApi.reducerPath]: loyaltyProgramApi.reducer,

	[profileUserApi.reducerPath]: profileUserApi.reducer,
	[profileEducationApi.reducerPath]: profileEducationApi.reducer,
	[profilePassportApi.reducerPath]: profilePassportApi.reducer,
	[profileLivingApi.reducerPath]: profileLivingApi.reducer,
	[profileWorkApi.reducerPath]: profileWorkApi.reducer,
	[profileSearchDoctorApi.reducerPath]: profileSearchDoctorApi.reducer,
	[profileInterestApi.reducerPath]: profileInterestApi.reducer,

	[materialEventsApi.reducerPath]: materialEventsApi.reducer,

	[OrganizationInfoAPI.reducerPath]: OrganizationInfoAPI.reducer,
});

export const store = configureStore({
	reducer: allSliceReducersReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat([
			authApi.middleware,
			userApi.middleware,
			pingApi.middleware,
			regionApi.middleware,
			loyaltyProgramApi.middleware,

			profileUserApi.middleware,
			profileEducationApi.middleware,
			profilePassportApi.middleware,
			profileLivingApi.middleware,
			profileWorkApi.middleware,
			profileSearchDoctorApi.middleware,
			profileInterestApi.middleware,

			materialEventsApi.middleware,

			OrganizationInfoAPI.middleware,
		]),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
